import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../../state'

@ngCore.Component({
  imports: [ds.table.Component, ds.layout.section.Component],
  selector: 'atn-rules-tab',
  standalone: true,
  styleUrls: ['./rules-tab.component.scss'],
  templateUrl: './rules-tab.component.html',
})
export class AtnRulesTabComponent {
  /**
   * @see {@link state.rate.rule.EcInjector.ec Rule EntityCollection}
   */
  public readonly ruleEc = ngCore.inject(state.rate.gl.rules.Collection)

  /** Canonical embedded table input for rules associated with the record. */
  public readonly tableConfig = {
    collection: this.ruleEc,
    view: {
      container: 'embedded',
      creation: () => this.addRuleButtonClickHandlerCallback(),
      search: true,
    },
  } satisfies ds.table.ec.Config.Input<state.rate.gl.rules.TypeParams>

  /**
   * @see {@link state.rate.gl.EcInjector.ec Gl EntityCollection}
   */
  private readonly _glEc = ngCore.inject(state.rate.gl.records.Collection)

  /**
   * Discards any active changes and marks {@link rule} for edit
   */
  public rulesTableRowClickHandler(
    rule: Readonly.Deep<state.rate.gl.rules.Entity>,
  ): void {
    // TODO: editing plugin should be improved to combine the below actions
    // (e.g. edit({ id, makeCurrent: { discardPrevious: true }))
    this.ruleEc.plugins.editingPlugin.feature.actions.discard
      .from('Table.Row.Clicked')
      .dispatch({ current: true })

    this.ruleEc.plugins.editingPlugin.feature.actions.edit
      .from('Table.Row.Clicked')
      .dispatch({ id: rule.id })
  }

  /**
   * Adds new rule to the cache with the pre-filled criteria. The default
   * criteria is `code = <code_of_the_gl_record>`
   */
  public addRuleButtonClickHandlerCallback = () => {
    const focusedGlRecord =
      this._glEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal()
    this.ruleEc.plugins.editingPlugin.feature.actions.edit
      .from('Rules.Table.Row.Click')
      .dispatch({
        edit: {
          input: {
            filter: {
              attributeId: GL_RECORD_CODE_ATTRIBUTE_ID,
              operator: ents.extra.rate.gl.Filter.Comparison.Operator.Equals,
              value:
                focusedGlRecord?.attributes?.find(
                  attr => attr.id === GL_RECORD_CODE_ATTRIBUTE_ID,
                )?.value ?? '',
            },
          },
        },
      })
  }
}

const GL_RECORD_CODE_ATTRIBUTE_ID: ents.core.dms.models.Attribute.Id =
  'attr:ent#!gl_exp#!entry:!code'
